import {useQuery} from "@tanstack/react-query";
import * as api from "../../../api";


export const useCountriesQuery = (enabled=true) => {
    return useQuery({
        queryKey: ['countries'],
        queryFn: () => api.Territory.getCountries(),
        enabled: enabled,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    })
}

export default useCountriesQuery;